import { capitalize } from '../../utils/capitalize.js';
import { ADDRESS_CONSTRAINTS } from '../address/constraints.js';
export const ADDRESS_FIELD_LABELS = {
    address: ADDRESS_CONSTRAINTS.address.label,
    city: ADDRESS_CONSTRAINTS.city.label,
    stateId: 'State',
    countryId: 'Country',
    zip: ADDRESS_CONSTRAINTS.zip.label,
};
/** The canonical field list, so a sixth field reaches every consumer at once. */
export const ADDRESS_FIELD_NAMES = Object.keys(ADDRESS_FIELD_LABELS);
/** Shared by the create and edit forms so one rule governs both. */
export function addAddressIssues(values, context) {
    const blankFieldNames = ADDRESS_FIELD_NAMES.filter((fieldName) => !values[fieldName]);
    if (blankFieldNames.length === 0)
        return;
    // WHY: an address is complete or absent -- a staged warehouse may omit it entirely, but once
    // any field is filled the rest are required too.
    const mayOmitEntirely = !values.activeFlag && !values.hasSavedAddress;
    if (mayOmitEntirely && blankFieldNames.length === ADDRESS_FIELD_NAMES.length)
        return;
    blankFieldNames.forEach((fieldName) => {
        context.addIssue({
            code: 'custom',
            message: `${capitalize(ADDRESS_FIELD_LABELS[fieldName].toLowerCase())} is required.`,
            path: [fieldName],
        });
    });
}
/** Undefined when every field is blank, which the forms only allow on an inactive warehouse. */
export function toLocationGroupAddressInput(values) {
    // WHY: the mapper runs on raw form values, before the schema parses -- so it trims here rather
    // than relying on the optionalForm* transforms, which only apply on parse.
    if (ADDRESS_FIELD_NAMES.every((fieldName) => !values[fieldName]?.trim()))
        return undefined;
    // The forms reject a partial address, so any field being filled means all five are -- a blank
    // here would have failed validation before reaching the mapper.
    return {
        address: values.address?.trim() ?? '',
        city: values.city?.trim() ?? '',
        stateId: values.stateId ?? '',
        countryId: values.countryId ?? '',
        zip: values.zip?.trim() ?? '',
    };
}
//# sourceMappingURL=address-form-rules.js.map